import gsap from 'gsap'

import ee from '../ee'

function fadeInHero(bgEl, contentEl) {
  return gsap
    .timeline()
    .to(bgEl, {
      autoAlpha: 1,
      ease: 'linear',
      duration: 0.5,
    })
    .to(contentEl, {
      autoAlpha: 1,
      ease: 'linear',
      duration: 1,
    })
}

function init() {
  let bgEl = document.querySelector('.article-hero-bg')
  let contentEl = document.querySelector('.article-hero-content')

  if (bgEl && contentEl) {
    fadeInHero(bgEl, contentEl)
  }
}

ee.addListener('initComponents', init)
